import React, { useRef, useState } from "react";
import { motion } from "framer-motion";
import { LuArrowUpRight } from "react-icons/lu";

export default function Footer({ className }) {
  const constraintsRef = useRef(null);
  const [_copied, setCopied] = useState(false);

  const initialStickers = [
    { id: "linkedin", text: "LINKEDIN", type: "pill", x: -140, y: 30, rotate: -8 },
    { id: "instagram", text: "INSTAGRAM", type: "pill", x: -40, y: -40, rotate: 12 },
    { id: "behance", text: "BEHANCE", type: "pill", x: 40, y: -10, rotate: -4 },
    { id: "facebook", text: "FACEBOOK", type: "pill", x: 100, y: 40, rotate: 15 },
    { id: "dribbble", text: "DRIBBBLE", type: "pill", x: 130, y: -30, rotate: -12 },
    { id: "seal-rock", type: "seal", x: -180, y: -20, rotate: 5, emoji: "🤘" },
    { id: "seal-kiss", type: "seal", x: -80, y: 25, rotate: -15, emoji: "👅" },
    { id: "seal-heart", type: "seal", x: 210, y: 20, rotate: 18, emoji: "⚡" }
  ];

  const handleCopyEmail = () => {
    navigator.clipboard.writeText("atelier@loungecoffe.com");
    setCopied(true);
    setTimeout(() => setCopied(false), 2500);
  };

  void handleCopyEmail;

  return (
    <>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
      <link href="https://fonts.googleapis.com/css2?family=Space+Mono:wght@400;700&family=Inter:wght@400;500;700;800;900&display=swap" rel="stylesheet" />
      <style>
        {`
          @keyframes footer-marquee {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
          .footer-animate-marquee {
            animation: footer-marquee 22s linear infinite;
          }
        `}
      </style>

      <section
        id="footer-section"
        className={"relative w-full bg-[#111111] text-[#FAF9F6] pt-16 pb-12 px-6 sm:px-12 md:px-16 overflow-hidden select-none border-t border-white/5 " + (className || "")}
      >
        {/* 1. Giant Editorial Heading: Marquee Ticker */}
        <div className="w-full overflow-hidden py-6 border-b border-white/10 flex bg-black/10">
          <div
            className="footer-animate-marquee whitespace-nowrap items-center gap-12 text-[6vw] sm:text-[5vw] md:text-[4vw] font-extrabold uppercase select-none flex"
            style={{ fontFamily: "Inter, sans-serif" }}
          >
            {/* Loop Segment 1 */}
            <span className="flex items-center gap-6">CONTACTS</span>
            <img src="https://cdn.jiro.build/Laounge%20Coffe/images/Cap1.png" alt="Lounge Coffe Cup" className="h-[8vw] max-h-[70px] min-h-[35px] w-auto object-contain filter drop-shadow-[0_12px_24px_rgba(255,122,0,0.2)] transform rotate-[-6deg] hover:scale-110 transition-transform duration-300" />
            <span className="flex items-center gap-6">LOUNGE COFFEE</span>
            <img src="https://cdn.jiro.build/Laounge%20Coffe/images/Cap2.png" alt="Lounge Coffe Cup" className="h-[8vw] max-h-[70px] min-h-[35px] w-auto object-contain filter drop-shadow-[0_12px_24px_rgba(255,122,0,0.2)] transform rotate-[8deg] hover:scale-110 transition-transform duration-300" />
            <span className="flex items-center gap-6">ATELIER</span>
            <img src="https://cdn.jiro.build/Laounge%20Coffe/images/Cap3.png" alt="Lounge Coffe Cup" className="h-[8vw] max-h-[70px] min-h-[35px] w-auto object-contain filter drop-shadow-[0_12px_24px_rgba(255,122,0,0.2)] transform rotate-[-4deg] hover:scale-110 transition-transform duration-300" />
            <span className="flex items-center gap-6">GET IN TOUCH</span>
            <img src="https://cdn.jiro.build/Laounge%20Coffe/images/Cap4.png" alt="Lounge Coffe Cup" className="h-[8vw] max-h-[70px] min-h-[35px] w-auto object-contain filter drop-shadow-[0_12px_24px_rgba(255,122,0,0.2)] transform rotate-[10deg] hover:scale-110 transition-transform duration-300" />

            {/* Loop Segment 2 (Duplicated for seamless loop scroll) */}
            <span className="flex items-center gap-6">CONTACTS</span>
            <img src="https://cdn.jiro.build/Laounge%20Coffe/images/Cap1.png" alt="Lounge Coffe Cup" className="h-[8vw] max-h-[70px] min-h-[35px] w-auto object-contain filter drop-shadow-[0_12px_24px_rgba(255,122,0,0.2)] transform rotate-[-6deg] hover:scale-110 transition-transform duration-300" />
            <span className="flex items-center gap-6">LOUNGE COFFEE</span>
            <img src="https://cdn.jiro.build/Laounge%20Coffe/images/Cap2.png" alt="Lounge Coffe Cup" className="h-[8vw] max-h-[70px] min-h-[35px] w-auto object-contain filter drop-shadow-[0_12px_24px_rgba(255,122,0,0.2)] transform rotate-[8deg] hover:scale-110 transition-transform duration-300" />
            <span className="flex items-center gap-6">ATELIER</span>
            <img src="https://cdn.jiro.build/Laounge%20Coffe/images/Cap3.png" alt="Lounge Coffe Cup" className="h-[8vw] max-h-[70px] min-h-[35px] w-auto object-contain filter drop-shadow-[0_12px_24px_rgba(255,122,0,0.2)] transform rotate-[-4deg] hover:scale-110 transition-transform duration-300" />
            <span className="flex items-center gap-6">GET IN TOUCH</span>
            <img src="https://cdn.jiro.build/Laounge%20Coffe/images/Cap4.png" alt="Lounge Coffe Cup" className="h-[8vw] max-h-[70px] min-h-[35px] w-auto object-contain filter drop-shadow-[0_12px_24px_rgba(255,122,0,0.2)] transform rotate-[10deg] hover:scale-110 transition-transform duration-300" />
          </div>
        </div>

        {/* 2. Sub-header details columns */}
        <div
          className="grid grid-cols-1 md:grid-cols-3 gap-6 py-6 text-[11px] sm:text-xs text-white/50 tracking-wider uppercase border-b border-white/10"
          style={{ fontFamily: "'Space Mono', monospace" }}
        >
          <div className="leading-relaxed max-w-xs">
            I'M HERE TO HELP YOU ELEVATE YOUR COFFEE EXPERIENCE INTO SOMETHING BRILLIANT.
          </div>
          <div className="flex md:justify-center items-center">
            JUST DROP US A LINE OR PLAY WITH STICKERS Below
          </div>
          <div className="flex md:justify-end items-center">
            &copy; 2026 ALL RIGHTS RESERVED
          </div>
        </div>

        {/* 3. Draggable Interactive Sticker Area */}
        <div
          ref={constraintsRef}
          className="relative w-full h-[320px] sm:h-[380px] md:h-[420px] mt-10 mb-8 bg-neutral-900/20 rounded-3xl border border-dashed border-white/5 flex items-center justify-center overflow-hidden cursor-grab active:cursor-grabbing"
        >
          {initialStickers.map((sticker) => {
            if (sticker.type === "pill") {
              return (
                <motion.div
                  key={sticker.id}
                  drag
                  dragConstraints={constraintsRef}
                  dragTransition={{ bounceStiffness: 600, bounceDamping: 20 }}
                  whileDrag={{ scale: 1.12, rotate: sticker.rotate + 10, zIndex: 50 }}
                  whileHover={{ scale: 1.05 }}
                  style={{
                    x: sticker.x,
                    y: sticker.y,
                    rotate: sticker.rotate,
                    fontFamily: "'Space Mono', monospace"
                  }}
                  className="absolute px-6 py-2.5 bg-[#FAF9F6] text-[#111111] text-xs sm:text-sm font-black rounded-full shadow-[0_12px_24px_rgba(0,0,0,0.5)] border border-neutral-200/80 cursor-grab active:cursor-grabbing flex items-center gap-2 select-none group"
                >
                  <span>{sticker.text}</span>
                  <LuArrowUpRight className="w-3.5 h-3.5 text-neutral-400 group-hover:text-[#FF7A00] transition-colors" />
                </motion.div>
              );
            }

            return (
              <motion.div
                key={sticker.id}
                drag
                dragConstraints={constraintsRef}
                dragTransition={{ bounceStiffness: 600, bounceDamping: 20 }}
                whileDrag={{ scale: 1.15, rotate: sticker.rotate - 12, zIndex: 50 }}
                whileHover={{ scale: 1.06 }}
                style={{
                  x: sticker.x,
                  y: sticker.y,
                  rotate: sticker.rotate,
                }}
                className="absolute w-[95px] h-[95px] sm:w-[110px] sm:h-[110px] rounded-full bg-[#FAF9F6] text-[#111111] shadow-[0_14px_28px_rgba(0,0,0,0.5)] border-2 border-dashed border-neutral-300 flex items-center justify-center cursor-grab active:cursor-grabbing select-none group"
              >
                <div className="absolute inset-1.5 rounded-full border border-neutral-200 flex items-center justify-center animate-[spin_24s_linear_infinite] pointer-events-none">
                  <svg className="absolute w-full h-full" viewBox="0 0 100 100">
                    <path
                      id={"textPath-" + sticker.id}
                      d="M 50, 50 m -34, 0 a 34,34 0 1,1 68,0 a 34,34 0 1,1 -68,0"
                      fill="none"
                    />
                    <text
                      className="text-[7.5px] tracking-[0.16em] fill-neutral-600 uppercase font-black"
                      style={{ fontFamily: "'Space Mono', monospace" }}
                    >
                      <textPath href={"#textPath-" + sticker.id} startOffset="0%">
                        Drag me • Drag me • Drag me •
                      </textPath>
                    </text>
                  </svg>
                </div>
                <span className="text-2xl sm:text-3xl z-10 filter drop-shadow">
                  {sticker.emoji}
                </span>
              </motion.div>
            );
          })}
        </div>
      </section>
    </>
  );
}